import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { Dimension, NewDimension } from '../models/dimension';
import { UNDERSCORE } from '../utils/constant';
import { formatDimension } from '../utils/number.format';

@Pipe({
	name: 'copoDimension',
})
@Injectable({ providedIn: 'root' })
export class DimensionPipe implements PipeTransform {
	transform(value?: Dimension | NewDimension, replacement = UNDERSCORE) {
		if (!value) {
			return replacement;
		}
		let thickness;
		let width;
		let length;
		const valueDimension = <Dimension> value;
		const valueNewDimension = <NewDimension> value;
		if (valueDimension.thickness && valueDimension.width) {
			thickness = valueDimension.thickness;
			width = valueDimension.width;
			length = valueDimension.length;
		} else if (valueNewDimension.thicknessDimension && valueNewDimension.widthDimension) {
			thickness = valueNewDimension.thicknessDimension;
			width = valueNewDimension.widthDimension;
			length = valueNewDimension.lengthDimension;
		}

		if (thickness === undefined || width === undefined) {
			return replacement;
		}
		return formatDimension(
			thickness,
			width,
			length,
			replacement
		);
	}
}
